import React from 'react';
import { Button } from '../../../../components';
import css from './AwardCard.css';
import { IconClockS } from '../../../../icons';

const Header = ({ children }) => <h3>{children}</h3>;

const Description = ({ children }) => <p className={css.description}>{children}</p>;

const Badge = ({ children }) => <div className={css.badge}>{children}</div>;

const Action = ({ onClick = () => null, children, disabled = false }) => (
    <>
        <p className={css.sidenote}>
            <IconClockS /> <span>Sofortige Gutschrift</span>
        </p>
        <Button onClick={onClick} disabled={disabled}>
            {children || 'Reward erhalten'}
        </Button>
    </>
);

export const AwardCard = ({ children }) => {
    return <div className={css.root}>{children}</div>;
};

AwardCard.Header = Header;
AwardCard.Description = Description;
AwardCard.Badge = Badge;
AwardCard.Action = Action;
